export { useGetKnowledgeHubConfig } from './use-get-knowledge-hub-config';
